// Pure validation logic for the inquiry & booking forms.
// Each validator returns an { fieldKey: true } object of fields in error.

export function validateInquiry({ form, d, pickupMode, returnTrip, returnMode, agreePrivacy, agreeCancellation }) {
  const e = {};
  ["full_name", "email", "confirm_email", "passengers", "service_type", "service_date", "pickup_time"].forEach((k) => { if (!form[k]) e[k] = true; });
  if (form.email && form.confirm_email && form.email !== form.confirm_email) e.confirm_email = true;

  const st = form.service_type;
  if (st === "point-to-point-transfer") {
    if (pickupMode === "airport") {
      if (!d.flight_number) e.flight_number = true;
      if (!d.flight_origin) e.flight_origin = true;
      if (!d.hotel && !d.dropoff_address) { e.hotel = true; e.dropoff_address = true; }
      if (!d.city_of_dropoff) e.city_of_dropoff = true;
    } else if (pickupMode === "port") {
      if (!d.port_name) e.port_name = true;
      if (!d.hotel && !d.dropoff_address) { e.hotel = true; e.dropoff_address = true; }
      if (!d.city_of_dropoff) e.city_of_dropoff = true;
    } else {
      if (!d.hotel && !d.pickup_address) { e.hotel = true; e.pickup_address = true; }
      if (!d.city_of_pickup) e.city_of_pickup = true;
      if (!d.dropoff_hotel && !d.dropoff_address) { e.dropoff_hotel = true; e.dropoff_address = true; }
      if (!d.city_of_dropoff) e.city_of_dropoff = true;
    }
    if (!d.luggage) e.luggage = true;
    if (returnTrip) {
      if (!d.return_date) e.return_date = true;
      if (!d.return_time) e.return_time = true;
      if (returnMode === "airport") {
        if (!d.return_flight_number) e.return_flight_number = true;
        if (!d.return_flight_origin) e.return_flight_origin = true;
      } else if (returnMode === "port") {
        if (!d.return_port_name) e.return_port_name = true;
      } else {
        if (!d.return_address) e.return_address = true;
      }
      if (!d.return_luggage) e.return_luggage = true;
    }
  } else if (st === "private-itinerary") {
    if (!d.pickup_address) e.pickup_address = true;
    if (!d.requests) e.requests = true;
  } else if (st === "shore-excursions") {
    if (!d.ship_name) e.ship_name = true;
    if (!d.port) e.port = true;
  } else if (st === "hours-disposition" || st === "shopping-leisure") {
    if (!d.pickup_address) e.pickup_address = true;
    if (!d.destination) e.destination = true;
    if (!d.hours) e.hours = true;
  }

  if (!agreePrivacy) e.agreePrivacy = true;
  if (!agreeCancellation) e.agreeCancellation = true;
  return e;
}

export function validateBooking({ form, pickupType, d, agreePrivacy, agreeCancellation }) {
  const e = {};
  ["full_name", "phone", "email", "confirm_email", "passengers", "service_date", "pickup_time"].forEach((k) => { if (!form[k]) e[k] = true; });
  if (form.email && form.confirm_email && form.email !== form.confirm_email) e.confirm_email = true;
  if (!pickupType) e.pickup_type = true;
  if (pickupType === "cruise") { if (!d.ship_name) e.ship_name = true; if (!d.port) e.port = true; }
  if (pickupType === "hotel") { if (!d.address) e.address = true; if (!d.city) e.city = true; }
  if (!agreePrivacy) e.agreePrivacy = true;
  if (!agreeCancellation) e.agreeCancellation = true;
  return e;
}
